import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from './redux/reducers';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { loadDefaultState } from './redux/helpers/loadDefaulState';
import {
  getAutoFill,
  getContext,
  getBookId,
} from './redux/helpers/getParams';

import LanguageHandler from './components/language/LanguageHandler';
import { browserNotSupported } from './redux/helpers';

const urlLangugeCode = new URL(window.location.href).searchParams.get('lang');
const lang = new LanguageHandler(urlLangugeCode);
const store = createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), applyMiddleware(thunk));
// preload layouts, images
const autofill = getAutoFill();
let bookId = getBookId();
const context = getContext();

if (getBookId() === null) {
  bookId = '00';
} else {
  bookId = getBookId();
}

// get book type
const bookContext = context !== undefined && context !== null ? context : 'consumer';
const autofillByLoadTest = autofill;
if (!browserNotSupported()) {
  loadDefaultState(store, bookId, autofillByLoadTest, bookContext, lang);
}

ReactDOM.render(
  <Provider store={store}>
    <App lang={lang} />
  </Provider>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js